<template>
  <div id="app">
    <MaintenanceBanner :src="MAINTENANCE_BANNER_SRC" />
    <ChromeWarning />
    <router-view />

    <Version />
  </div>
</template>

<script>
import MaintenanceBanner from '@/components/MaintenanceBanner.vue'
import ChromeWarning from '@/components/dialogs/ChromeWarning.vue'
import Version from '@/components/utility/Version.vue'

export default {
  components: {
    MaintenanceBanner,
    ChromeWarning,
    Version
  },

  data () {
    return {
      MAINTENANCE_BANNER_SRC: process.env.VUE_APP_MAINTENANCE_WINDOW_JSON || ''
    }
  }
}
</script>
